import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import MetaPixel from "@/components/MetaPixel";
import MicrosoftClarity from "@/components/MicrosoftClarity";
import Home from "@/pages/Home";
import Guide from "@/pages/Guide";
import Numeri from "@/pages/Numeri";
import ChiSiamo from "@/pages/ChiSiamo";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Termini from "@/pages/Termini";
import Contatti from "@/pages/Contatti";
import TrasparenzaAI from "@/pages/TrasparenzaAI";
import ArticoloGuida from "@/pages/ArticoloGuida";
import Blog from "@/pages/Blog";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/guida" element={<Guide />} />
              <Route path="/guida/:slug" element={<ArticoloGuida />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/numeri-utili" element={<Numeri />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/termini" element={<Termini />} />
              <Route path="/trasparenza-ai" element={<TrasparenzaAI />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
          <GoogleAnalytics />
          <MetaPixel />
          <MicrosoftClarity />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
